import React from 'react';

import { Divider } from '@mui/material';
import { observer } from 'mobx-react';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './PaymentDetailsWidget.module.scss';
import { scanIqCurrentSubscriptionPlanStore } from '../../../stores/scanIqCurrentSubscriptionPlanStore';
import { getFormattedLocalDate } from '../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../shared/constants/apiDateFormat';
import { getFlagsObject } from '../../../../shared/utils/sortingAndGroupingUtil';
import { BILLING_PERIOD_TYPE } from '../../../constants/billingPeriodType';
import { InfoBox, TitledInfo } from '../../../../shared/components/ui-components';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { getHumanizeBillingPeriodType } from '../../../utils/getHumanizeBillingPeriodType/getHumanizeBillingPeriodType';

const PaymentDetailsWidget = observer(() => {
  const { currentSubscriptionPlan, paymentStatusFlag } =
    scanIqCurrentSubscriptionPlanStore;

  if (!currentSubscriptionPlan) {
    return null;
  }

  const { lastTransaction } = currentSubscriptionPlan;
  const { billingInfo } = lastTransaction;

  const formattedNextBillingDate = getFormattedLocalDate(
    billingInfo.nextBillingDateTime,
    localDataFormat,
  );

  const formattedActiveSinceDate = getFormattedLocalDate(
    billingInfo.activeSinceDateTime,
    localDataFormat,
  );

  const billingPeriodTypeFlags = getFlagsObject(BILLING_PERIOD_TYPE, [
    billingInfo.billingPeriodType || '',
  ]);

  return (
    <InfoBox title="Payment Details" customContentPadding>
      <div className={classes.paymentDetailsTableView}>
        <GridTableRow variant="unstyled" className={classes.billInfoRow}>
          <GridTableCell variant="title">Billing Info</GridTableCell>
          <GridTableCell className="private-info">
            <p>{billingInfo.customerName}</p>
            <p>{billingInfo.billingEmail}</p>
          </GridTableCell>
        </GridTableRow>
        <Divider className={classes.divider} />
        <GridTableRow variant="unstyled" className={classes.billingDatesRow}>
          <GridTableCell>
            <TitledInfo title="Billing Period">
              {billingInfo.billingPeriodType &&
                !paymentStatusFlag.CANCELED &&
                !billingPeriodTypeFlags.DAILY && (
                  <TitleWithDescription
                    title={getHumanizeBillingPeriodType(billingInfo.billingPeriodType)}
                    description={
                      billingInfo.nextBillingDate &&
                      `Next billing date: ${formattedNextBillingDate}`
                    }
                    titleFont="inherit"
                    direction="row"
                    className="private-info"
                  />
                )}
            </TitledInfo>
          </GridTableCell>
          <GridTableCell>
            <TitledInfo title="Active Since">
              {billingInfo.activeSinceDate &&
                !paymentStatusFlag.CANCELED &&
                !billingPeriodTypeFlags.DAILY && <div>{formattedActiveSinceDate}</div>}
            </TitledInfo>
          </GridTableCell>
        </GridTableRow>
      </div>
    </InfoBox>
  );
});

export { PaymentDetailsWidget };
